/*
    node_js
    2/22/2021 7:43 PM
    by Oleksandr
*/
import auth from '../auth/Auth'
import {withRouter} from "react-router-dom";
import Button from "@material-ui/core/Button";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContentText from "@material-ui/core/DialogContentText";
import TextField from "@material-ui/core/TextField";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import Dialog from "@material-ui/core/Dialog";
import React, {useEffect, useState} from "react";
import Window from "./cwp/graphics/windows/Window";
import {makeStyles} from "@material-ui/core/styles";
import {withStyles} from "@material-ui/core";

const CssTextField = withStyles(theme => ({
    root: {
        '& .MuiFormLabel-root.Mui-focused': {
            color: 'lightgrey',
        }
    },
}))(TextField);


const Login = (props) => {

    const [isLoading, setIsLoading] = useState(true);
    const [login, setLogin] = useState('');
    const [password, setPassword] = useState('');

    useEffect(() => {
        auth.validateToken((resp) => {
            if (resp.success) {
                props.history.push("/home")
            }
            setIsLoading(false);
        });
    }, [])
    document.getElementsByTagName('body')[0].style.position='';




    if (isLoading) {
        return (<Dialog open>
            <DialogTitle>Loading...</DialogTitle>
        </Dialog>)
    } else {
        return (
            <div style={{width:'100%', display:'flex', justifyContent: 'center'}}>

                    <Window style={{top:'30%'}} label='Login' hideCloseButton={true} content={<>
                        <DialogContent>
                            <DialogContentText key='dialogContentText' id='dialogContentText'>
                                To login to this App, please enter your <b>lvivacc.site</b> login and password here.
                            </DialogContentText>

                            <CssTextField
                                autoFocus
                                margin="dense"
                                id="login"
                                label="Login"
                                type="login"
                                fullWidth
                                onChange={(e) => setLogin(e.target.value)}
                            />
                            <CssTextField
                                margin="dense"
                                id="password"
                                label="Password"
                                type="password"
                                // InputLabelProps={{className:classes.label}}
                                fullWidth
                                onChange={(e) => setPassword(e.target.value)}
                            />
                        </DialogContent>
                        <DialogActions>
                        <span className={'buttonSDD'}
                              style={{width:'100%'}}
                              onClick={() => {
                                  auth.login(login, password, (resp) => {
                                      if (resp.success) {
                                          props.history.push("/home")
                                      } else {
                                          setLogin('');
                                          setPassword('');
                                          document.getElementById('login').value = '';
                                          document.getElementById('login').focus();
                                          document.getElementById('password').value = '';
                                          document.getElementById('dialogContentText').innerHTML = 'Invalid Login or Password';
                                          document.getElementById('dialogContentText').style.color = 'red';
                                      }
                                  })
                              }}>
                            Login
                        </span>
                        </DialogActions>
                        {/*</form>*/}
                    </>} />

            </div>

        )
    }

}
export default withRouter(Login);